export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50">女神漫画</span>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                女神漫画网官网，专注提供免费韩漫、日漫、国漫全集在线阅览。热门漫画排行榜推荐与下拉式阅读体验，为每一位漫画爱好者打造舒心的阅读空间。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                <li><a href="#hero" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热门排行</a></li>
                <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选专题</a></li>
                <li><a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">最新更新</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h3>
              <ul className="space-y-2.5">
                <li><a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">编辑推荐</a></li>
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">漫画索引</a></li>
                <li><a href="#media" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精彩视频</a></li>
                <li><a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">合作伙伴</h3>
              <div className="grid grid-cols-3 gap-3">
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
                <div className="h-10 rounded bg-background-800/50 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">合作伙伴</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 女神漫画网官网. 本站所有漫画资源均来自网络，仅供爱好者交流学习使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}